import { type FraxlendPairPauseState, hasAnyFraxlendPause } from '@/features/isolated/types/FraxlendPairPauseState'
import { assets } from '@/ui/assets'
import { Tooltip, TooltipContentLong, TooltipTrigger } from '@/ui/atoms/tooltip/Tooltip'
import { TooltipContentLayout } from '@/ui/atoms/tooltip/TooltipContentLayout'

import { IconPill } from '../../atoms/icon-pill/IconPill'
import { Typography } from '@/ui/atoms/typography/Typography'

interface FraxlendPauseIndicatorProps {
  state: FraxlendPairPauseState
}

const PAUSE_LABELS: Array<[keyof FraxlendPairPauseState, string]> = [
  ['interestPaused', 'Interest accrual'],
  ['liquidatePaused', 'Liquidations'],
  ['repayPaused', 'Repays'],
  ['withdrawPaused', 'Withdrawals'],
]

export function FraxlendPauseIndicator({ state }: FraxlendPauseIndicatorProps) {
  if (!hasAnyFraxlendPause(state)) return null

  const pausedItems = PAUSE_LABELS.filter(([key]) => state[key]).map(([, label]) => label)

  return (
    <Tooltip>
      <TooltipTrigger className="flex">
        <IconPill icon={assets.pause} className="shrink-0 border border-border bg-secondary" />
      </TooltipTrigger>
      <TooltipContentLong>
        <TooltipContentLayout>
          <TooltipContentLayout.Header>
            <TooltipContentLayout.Icon src={assets.pause} />
            <TooltipContentLayout.Title>Pair pauses</TooltipContentLayout.Title>
          </TooltipContentLayout.Header>

          <TooltipContentLayout.Body>
            <Typography variant="p" className="text-muted-foreground text-sm">
              The following operations are paused on this isolated pair contract: {pausedItems.join(', ')}.
            </Typography>
          </TooltipContentLayout.Body>
        </TooltipContentLayout>
      </TooltipContentLong>
    </Tooltip>
  )
}
